import { render } from "./FrontpageCarouselItem.vue?vue&type=template&id=28c4b558"
import script from "./FrontpageCarouselItem.vue?vue&type=script&lang=js"
export * from "./FrontpageCarouselItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__